











import {Component, Vue, Watch} from 'vue-property-decorator';
import {Sync} from 'vuex-pathify';
import {FeathersVuexFindAll} from '@/utils';
import {nil} from '@/common';
import {Mixins} from 'vue-property-decorator';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
import {groupBy, get} from 'lodash';
import KeyedImagesMixin from '@/mixins/KeyedImagesMixin.vue';

@Component({
    components: {},
})
export default class BookingChooseCategory extends Mixins(ScreenSizeMixin, KeyedImagesMixin) {
    @Sync('booking/category') public selectedCategory!: any;
    @Sync('booking/step') public step!: number;
    @Sync('booking/serviceType') public serviceType!: string;
    @Sync('booking/tier') public selectedTier!: any;

    public isHair = null;
    public initialSelection: boolean = false;
    public categories: any[] = [];
    public tiers: any[] = [];
    public serviceTypes = [
    ];

    @Watch('selectedCategory')
    public onCategoryChanged(value: string, oldValue: string) {
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                actionField:{'step':2}
            }
        });
        this.step++;
    }

    public created() {

        this.getCategories();
        this.getServiceTypes();
    }
    public mounted() {

    }
    public async getCategories() {
        const cats = await FeathersVuexFindAll(this.$FeathersVuex.Category, {query: {$sort: {sort: 1}}});
        for (const category of cats) {
            category.image = [`/img/categories/${category._id}.jpeg`, `/img/categories/${category._id}.jpg`];
        }
        this.categories = cats;
    }

    public async getTiers() {

    }
    public async getServiceTypes() {
        this.serviceTypes = await FeathersVuexFindAll(this.$FeathersVuex.ServiceType, {});
    }
    public triggerCategorySelected(category: any) {
        this.selectedCategory = category;
        this.initialSelection = true;
    }
}
